import { TextField, TextFieldProps, styled } from '@mui/material';

export const StyledTextField = styled((props: TextFieldProps) => (
  <TextField
    {...props}
    variant="filled"
    InputProps={{
      disableUnderline: true,
      ...props.InputProps,
    }}
    InputLabelProps={{ shrink: true, ...props.InputLabelProps }}
  />
))(({ theme, multiline }) => ({
  '& .MuiFilledInput-root': {
    overflow: 'hidden',
    color: theme.palette.dsBase.v200,
    borderRadius: 16,
    padding: theme.spacing(1, 0.5, 0.25),
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.dsSurface.v100 : theme.palette.dsSurface.v300,
    border: '1px solid transparent',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    '&:hover, &.Mui-focused': {
      borderColor: theme.palette.mode === 'light' ? theme.palette.dsSurface.v400 : theme.palette.dsSurface.v200,
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.dsBase.v100 : theme.palette.dsSurface.v300,
    },
  },
  '& .MuiFormLabel-root': {
    color: theme.palette.dsNeutral.v400,
    fontWeight: theme.typography.textBase500.fontWeight,
    margin: theme.spacing(0.5, 0.5, 0, 0.5),
    '&.Mui-focused': {
      color: theme.palette.dsNeutral.v400,
    },
  },
  '& .MuiSelect-select': {
    backgroundColor: 'transparent !important',
  },
  ...(multiline && {
    '& .MuiInputBase-inputMultiline': {
      padding: theme.spacing(3, 1.5),
    },
  }),
}));

export const SearchField = styled(StyledTextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    height: theme.spacing(4),
    padding: theme.spacing(0, 0, 0, 0.5),
    borderRadius: 28,
  },
  '& .MuiFilledInput-input': {
    fontSize: theme.typography.textS500.fontSize,
    padding: theme.spacing(1.5, 2),
    paddingLeft: theme.spacing(1),
    '&::placeholder': {
      color: theme.palette.dsNeutral.v300,
    },
  },
}));
